<template>
  <div :class="$vuetify.breakpoint.mobile ? 'cmp-header mHeader':'cmp-header pcHeader'" ref="cmpHeader">
    <v-app-bar app
      color="white"
      elevate-on-scroll
    >
      <v-app-bar-nav-icon @click="drawer=true" v-if="$vuetify.breakpoint.mobile"></v-app-bar-nav-icon>

      <v-spacer class="spacer-header">
        <img src="../../assets/logo.png" v-if="!$vuetify.breakpoint.mobile" @click="jumpMain" style="cursor: pointer">
        <div class="top-nav" v-if="!$vuetify.breakpoint.mobile">
          <div class="nav-header" v-for="(item,index) in $t('header')" :key="index" @click="pathLink(item,index)" @mouseenter="headerViewIndex = index" @mouseleave="headerViewIndex = ''">
            <div class="item" v-if="index != 0">{{item}}</div> 
            <div v-if="headerViewIndex == index && index == 2" class="nav-headerView">
              <ul>
                <li v-for="(item,index) in newsViewList" :key="index" @mouseenter="liViewIndex = index" @mouseleave="liViewIndex = ''" :style="{ color: index ===  liViewIndex ? '#4aa3ca' : ''}" @click.stop="newsJump(item)">
                  {{ lang == 'zh' ? item.nameZh : (item.nameEn?item.nameEn:item.nameZh)}}
                </li>
              </ul>
            </div>
            <div v-if="headerViewIndex == index && index == 3" class="nav-headerView">
              <ul>
                <li v-for="(item,index) in ipViewList" :key="index" @mouseenter="liViewIndex = index" @mouseleave="liViewIndex = ''" :style="{ color: index ===  liViewIndex ? '#4aa3ca' : ''}" @click.stop="ipJump(item)">
                  {{ lang == 'zh' ? item.sectionName : (item.sectionNameEnUs?item.sectionNameEnUs:item.sectionName) }}
                </li>
              </ul>
            </div>
          </div>
          <div class="langImg">
            <img :src="$i18n.locale=='zh' ? lanImgEn: lanImgZh" v-if="!$vuetify.breakpoint.mobile" @click="changeLanguage" style="cursor: pointer;">
          </div>
        </div>
      </v-spacer>
    </v-app-bar>

    <v-navigation-drawer v-if="$vuetify.breakpoint.mobile"
      v-model="drawer"
      fixed
      temporary
      width="50%"
      class="navigationDrawer"
    >
      <v-list
        nav
        dense
      >
      
        <v-list-item-group
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item v-for="(item,index) in $t('header')" :key="index" @click="pathLink(item,index)" :class="(item == '新闻资讯' || item == '我们的IP') ? 'ip_group' : ''">
            <v-list-item-title v-if="item == '新闻资讯' || item == 'News'" clipped v-model="drawer">
              <v-list-group active-color="#000">
                <template #activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{item}}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template>
                  <v-list-item v-for="(item,index) in newsViewList" :key="index"  @click.stop="newsJump(item)">
                    <v-list-item-title>{{ lang == 'zh' ? item.nameZh : (item.nameEn ? item.nameEn : item.nameZh)}}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list-group>
            </v-list-item-title>

            <v-list-item-title v-else-if="item == '我们的IP' || item == 'Our IP'" clipped v-model="drawer">
              <v-list-group active-color="#000">
                <template #activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{item}}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <template>
                  <v-list-item v-for="(item,index) in ipViewList" :key="index"  @click.stop="ipJump(item)">
                    <v-list-item-title>{{ lang == 'zh' ? item.sectionName : (item.sectionNameEnUs ? item.sectionNameEnUs : item.sectionName) }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list-group>
            </v-list-item-title>
            <v-list-item-title v-else>{{item}}</v-list-item-title>
          </v-list-item>
          
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import ipApi from "../../api/ip";
import indexApi from "../../api/index";
  export default {
    data() {
      return {
        drawer: false,
        headerViewIndex:'',
        ipViewList:[],
        liViewIndex:'',
        //link对应上面的list
        headerLink:[
          { name:'首页',path: '/'},//首页
          { name:'关于我们',path: '/about'},//关于我们
          { name:'新闻资讯',path: '/news'},//新闻资讯
          { name:'我们的IP',path: '/ip'},//我们的IP
          { name:'业务范围',path: '/vocationalWork'},//业务范围
          { name:'新零售',path: '/channels?sectionCode=ac_channels_popup_shop'},//商场介绍
          { name:'联系我们',path: '/'},//首页'/',//联系我们
        ],
        newsViewList: [ 
          { nameZh:'新闻' ,nameEn:'News'},
          { nameZh:'市场活动' ,nameEn:'Marketing Activities'},
        ],
        lanImgZh: '',
        lanImgEn:''
      }
    },
    computed:{
        //获取当前语言
        lang() {
            return this.$i18n.locale;
        }
    },
    activated(){
      let headerView = document.querySelector('.cmp-header');
      if( this.$route.path === '' || this.$route.path === '/home' || this.$route.path === '/'){
        headerView.style.height = '0px';
        headerView.style.display = 'none';
      }else{
        headerView.style.display = 'block';
        headerView.style.height="100%"
      }
    },
    async mounted(){
      let { data: viewIpList } = await ipApi.getIpNameList();
      let { data: translateList } = await indexApi.getTransLateList();
      this.lanImgZh = translateList.picturesZhCn;
      this.lanImgEn = translateList.picturesEnUs ? translateList.picturesEnUs : translateList.picturesZhCn;
      this.ipViewList = viewIpList.length>0 ? viewIpList[0].children : [];

      document.addEventListener("scroll", ()=>{
        let headerView = document.querySelector('.cmp-header');
        if( this.$route.path === '' || this.$route.path === '/home' || this.$route.path === '/'){
          if( document.documentElement.scrollTop >= 100 ) {
            headerView.style.display = 'flex';
            headerView.style.height="100%"
          }else{
            headerView.style.height = '0px';
            headerView.style.display = 'none';
          }
        }else{
          headerView.style.display = 'block';
          headerView.style.height="100%"
        }
      });
    },
    methods:{
      changeLanguage(){
          this.$i18n.locale=='zh'?this.$i18n.locale='en':this.$i18n.locale='zh';   //设置中英文模式
          localStorage.setItem('languageSet',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
      },
      ipJump(item){
        this.$router.push( {path:'/ip',query:{ sectionCode: item.sectionCode || 'ac_ip_Doraemon'}} )
      },
      newsJump(item){
        let type = this.lang == 'zh' ? item.nameZh : item.nameEn
        switch(type){
          case '新闻':
          case 'News':
            this.$router.push( '/news' );
            break;
          case '市场活动':
          case 'Marketing Activities':
            this.$router.push( '/market' );
            break;
        }
      },
      jumpMain(){
        let headerView = document.querySelector('.cmp-header');
        headerView.style.height = '0px';
        headerView.style.display = 'none';
        this.$router.push('/');
      },
      pathLink(name,index){
        if( this.headerLink[index].path === '/' ){
          let headerView = document.querySelector('.cmp-header');
          headerView.style.height = '0px';
          headerView.style.display = 'none';
        }
        if( index == 2 || index == 3) {
          this.headerViewIndex = name;
          return
        }
        if( index == 6){
          this.$router.push( {path:'/',query:{ contact: new Date().getTime()}})
          return
        }
        this.headerViewIndex =  '';
        this.$router.push(this.headerLink[index].path)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .spacer-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    img{
      height: 30px;
      margin-left: 15%;
    }
    z-index: 998;
  }
.mHeader{
  margin-bottom: 56px;
  height: auto!important;
}
.pcHeader{
  margin-bottom: 64px;
}

.ip_group{
  padding-left: 0!important;
}
::v-deep .v-list-item__title{
  line-height: 2rem!important;
  font-size: 2rem!important;
}
.cmp-header {
  display: block;
  height: 100%;
  .top-nav {
    padding-left: 50px;
    display: flex;
    margin-right: 15%;
    width: 50%;
    justify-content: space-around;
    align-items: center;
    font-size: 15px;
    .item {
      margin-right: 20px;
      cursor: pointer;
    }
    .langImg{
      width:22px;
      height: 22px;
      // margin-left: -25px;
      img{
        height: 100%;
        width: 100%;
      }
    }
    .nav-header{
      position: relative;
      
      .item{
        line-height: 50px;
      }
      .nav-headerView{
        line-height: 20px;
        position: absolute;
        top: 50px;
        background: #fff;
        width: 120px;
        box-shadow: 0 0 4px #888;
        border-radius: 10px;
        transform: translateX(-30px);
        ul{
          padding-left: 0;
        }
        li{
          text-align: center;
          list-style: none;
          padding: 12px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>